import React from 'react'
import {FormFeedback} from "reactstrap";

const renderTextarea = ({ input, label, type, meta: { touched, error } }) => (
    <span>
        <textarea {...input} placeholder={label} type={type} className={`form-control ${touched && error && "is-invalid"}`} style={{color: "#000000"}}/>
        {touched && error && <FormFeedback className="invalid-feedback" style={{display: "block"}}>{error}</FormFeedback>}
    </span>
)

export default renderTextarea


// WEBPACK FOOTER //
// ./src/renderTextarea.js